import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const Modal = styled.div`
  z-index: 3;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 75%;
  min-height: 70px;
  background-color: #fff;
  border: 1px solid #000;
  border-radius: 10px;
`;

export const ContainerTable = styled.table`
  display: block;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Variables.colorOrange};
  }
`;

export const ContainField = styled.td`
  padding: 0 10px;
  width: 130px;
  border: 1px solid #000;
  text-align: center;
`;
